import { useCallback, useState } from "react";

/**
 * boolean open/close state 用の小さな primitive。 modal 開閉や折りたたみ等で
 * useState(false) + 2 つの open / close handler を毎回宣言する boilerplate を集約する。
 *
 * 戻り値は 3-tuple:
 *  [0] 現在の boolean (= true = open)
 *  [1] open function (= setValue(true))
 *  [2] close function (= setValue(false))
 *
 * 任意の bool で set したい場合 (= 外部 callback の引数に setter を渡す等) は
 * useState を直接使うか、 別 hook (= useDisclosure 等) を検討する。
 */
export function useToggle(
  initial = false,
): readonly [boolean, () => void, () => void] {
  const [value, setValue] = useState(initial);
  const open = useCallback(() => {
    setValue(true);
  }, []);
  const close = useCallback(() => {
    setValue(false);
  }, []);
  return [value, open, close];
}
